<template>
    <div class="d-inline-flex" v-if="deviceData.state != null">
        <v-switch
            v-model="deviceData.state.value"
            inset
            dense
            hide-details
            class="pa-0"
            @click="changeDeviceState"
            :loading="loading"
            color="#FF8484"
            :disabled="deviceData.is_action || deviceData.disabled"
        ></v-switch>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "DeviceSwitchEnable",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        }
    },
    data() {
        return {
            deviceData: {},
            loading: false,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
    },
    methods: {
        changeDeviceState() {
            if (!this.deviceData.is_action) {
                this.loading = true;
                this.deviceData.disabled = true;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                }
                this.disabledTimeout = setTimeout(() => {
                    this.deviceData.disabled = false;
                    this.loading = false;
                    this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
                }, LOADING_TIMEOUT);
                this.$http.put('/devices/guest/device/' + this.deviceData.uid + '/state', {
                    value: this.deviceData.state.value
                })
                    .catch((error) => {
                        if (this.disabledTimeout) {
                            clearTimeout(this.disabledTimeout);
                        }
                        this.deviceData.disabled = false;
                        this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
                        this.loading = false;
                        console.log(error);
                    });
            }
        },
    },
}
</script>